import React from 'react';
import { ChangeForm } from 'js/components/common/ChangeForm';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

import * as hooks from './hooks';
import * as Types from './types';
import { DYNAMIC_CHANGE_PASSWORD, DEFAULT_FORM_NAME } from './constants';

export const DynamicChangePasswordBare: React.FC<Types.IChangePasswordProps> = ({
    error,
    form,
    onClose,
    onSuccess,
    isPasFlow,
    showOldPassword
}) => {
    const { formName } = useComponentConfig<Types.IChangePasswordConfig>();
    const changePassword = hooks.useChangePassword();
    const changePasswordByPas = hooks.useChangePasswordByPas({ onSuccess, onClose, showOldPassword });

    return (
        <ChangeForm
            formError={error}
            formName={form || formName || DEFAULT_FORM_NAME}
            onSubmit={isPasFlow ? changePasswordByPas : changePassword}
        />
    );
};

export const DynamicChangePassword = withComponent({
    tkPrefix: 'playtech.mobile.system.dynamic-change-password.'
})(DynamicChangePasswordBare);

componentService.registerPageComponents({ [DYNAMIC_CHANGE_PASSWORD]: DynamicChangePassword });
